import { render, staticRenderFns } from "./ModalUserServiceFee.vue?vue&type=template&id=2a81257c&"
import script from "./ModalUserServiceFee.vue?vue&type=script&lang=js&"
export * from "./ModalUserServiceFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports